import { createContext, useReducer, useEffect, ReactNode, Dispatch } from "react";
import { User, AuthAction } from "../types";

export interface AuthContextType {
    user: User | null;
    dispatch: Dispatch<AuthAction>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const authReducer = (state: { user: User | null }, action: AuthAction): { user: User | null } => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload || null };
        case 'LOGOUT':
            return { user: null };
        default:
            return state;
    }
};

interface AuthContextProviderProps {
    children: ReactNode;
}

export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null
    });

    console.log("AuthContext state: ", state);

    useEffect(() => {
        const fetchAdmin = async () => {
            if (!user) return;
            
            const res = await fetch(`${process.env.REACT_APP_PATH}/api/admin/` + user.ID, {
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            const json = await res.json();

            if (res.ok) {
                if (json[0].rights !== user.rights) {
                    localStorage.removeItem('user');
                    dispatch({ type: 'LOGOUT' });
                }
            }
        };

        const userString = localStorage.getItem('user');
        const user: User | null = userString ? JSON.parse(userString) : null;
        
        dispatch({ type: 'LOGIN', payload: user });
        
        if (user) {
            fetchAdmin();
        }
    }, []);

    return (
        <AuthContext.Provider value={{ ...state, dispatch }}>
            {children}
        </AuthContext.Provider>
    );
};
